module.exports = __webpack_public_path__ + "static/media/icon_bookshelf_black.173c9cd4.png";